import React, { useCallback, useEffect, useState } from "react";
// import jsPDF from "jspdf";
import Calender from "../../../components/dashboard-components/Calender";
import SearchComponent from "../../../components/dashboard-components/SearchComponent";

import TransactionTable from "../../../components/dashboard-components/transactionTable";
import { useTransactionActivities } from "../../../sevices/hooks/account";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { useSearchParams } from "react-router-dom";
import { ChevronDown, Download } from "lucide-react";
import Calendar from "../../../components/dashboard-components/Calender";
// Add this type augmentation
declare module "jspdf" {
  interface jsPDF {
    autoTable: (options: any) => jsPDF;
  }
}

// Types
interface TransactionFilters {
  page: number;
  pageSize: number;
  currency?: string;
  date?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
}

export const CURRENCIES = [
  { value: "NGN", label: "Nigerian Naira (NGN)" },
  { value: "USD", label: "US Dollar (USD)" },
  { value: "EUR", label: "Euro (EUR)" },
  { value: "GBP", label: "British Pound (GBP)" },
  { value: "USDT", label: "USD TETHER (USDT)" },
  { value: "USDC", label: "USD COIN (USDC)" },
] as const;

const Transactions: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState<TransactionFilters>({
    page: parseInt(searchParams.get("page") || "1"),
    pageSize: 15,
    currency: searchParams.get("currency") || undefined,
    date: searchParams.get("date") || "select",
    fromDate: searchParams.get("fromDate") || undefined,
    toDate: searchParams.get("toDate") || undefined,
    search: searchParams.get("search") || undefined,
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
 const getHeaderText = () => {
   if (!filters.currency) return "All Transactions";
   return `${filters.currency} Transactions`;
 };
  // Fetch data with filters
  const { data: trx, isLoading } = useTransactionActivities({
    ...Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== "" && value !== "select") {
        if (key === "date" && value === "select") return acc;
        if (
          (key === "fromDate" || key === "toDate") &&
          filters.date === "select"
        ) {
          return acc;
        }
        //@ts-ignore
        acc[key] = value;
      }
      return acc;
    }, {} as Partial<TransactionFilters>),
  });

  // Update URL params when filters change
  useEffect(() => {
    const newParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        newParams.set(key, value.toString());
      }
    });
    setSearchParams(newParams, { replace: true });
  }, [filters, setSearchParams]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const dropdown = document.getElementById("currency-dropdown");
      if (dropdown && !dropdown.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = useCallback((query: string) => {
    setFilters((prev) => ({
      ...prev,
      search: query || undefined,
      page: 1,
    }));
  }, []);

  const handleDateChange = useCallback(
    (filterType: string, from?: string, to?: string) => {
      setFilters((prev) => ({
        ...prev,
        date: filterType,
        fromDate: filterType === "customDate" ? from : undefined,
        toDate: filterType === "customDate" ? to : undefined,
        page: 1,
      }));
    },
    []
  );

  const handlePageChange = useCallback((newPage: number) => {
    setFilters((prev) => ({
      ...prev,
      page: newPage,
    }));
  }, []);

  const handleCurrencyChange = useCallback((currency: string) => {
    setFilters((prev) => ({
      ...prev,
      currency: currency || undefined,
      page: 1,
    }));
    setIsDropdownOpen(false);
  }, []);

  const handleExportPDF = useCallback(() => {
    if (!trx?.data?.data) return;

    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Transaction Report", 14, 22);

    doc.setFontSize(10);
    let filterText = `Date Filter: ${filters.date}`;
    if (filters.fromDate && filters.toDate) {
      filterText += ` (${filters.fromDate} to ${filters.toDate})`;
    }
    if (filters.currency) {
      filterText += ` | Currency: ${filters.currency}`;
    }
    doc.text(filterText, 14, 30);

    const tableData = trx.data.data.map(
      (
        item: {
          id: any;
          FullName: any;
          type: any;
          amount: { toLocaleString: () => any };
          currency: any;
          status: any;
        },
        index: number
      ) => [
        index + 1,
        item.id,
        item.FullName,
        item.type,
        item.amount.toLocaleString(),
        item.currency,
        item.status,
      ]
    );

    doc.autoTable({
      head: [
        [
          "S/N",
          "Transaction ID",
          "Full Name",
          "Type",
          "Amount",
          "Currency",
          "Status",
        ],
      ],
      body: tableData,
      startY: 35,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [0, 102, 204] },
    });

    doc.save(`transactions-${new Date().toISOString().split("T")[0]}.pdf`);
  }, [trx?.data?.data, filters]);

  return (
    <div className="min-h-screen space-y-6 bg-white p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">{getHeaderText()}</h1>
        <Calendar
          onDateChange={handleDateChange}
          initialFilter={filters.date || "today"}
        />
      </div>

      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 flex-1">
          <SearchComponent
            placeholder="Search transactions..."
            onSearch={handleSearch}
          />

          <div className="relative" id="currency-dropdown">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center justify-between w-48 px-4 py-2 text-sm bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <span className="block truncate">
                {filters.currency
                  ? CURRENCIES.find((c) => c.value === filters.currency)?.label
                  : "All Currencies"}
              </span>
              <ChevronDown className="w-4 h-4 ml-2" />
            </button>

            {isDropdownOpen && (
              <div className="absolute z-10 w-48 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div className="py-1">
                  <button
                    onClick={() => handleCurrencyChange("")}
                    className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                  >
                    All Currencies
                  </button>
                  {CURRENCIES.map((currency) => (
                    <button
                      key={currency.value}
                      onClick={() => handleCurrencyChange(currency.value)}
                      className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                    >
                      {currency.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <button
          onClick={handleExportPDF}
          className="flex items-center gap-2 rounded-lg bg-[#676767] px-4 py-2 text-sm font-medium text-white hover:bg-[#0eb683]"
        >
          <Download className="h-4 w-4" />
          <span>Export PDF</span>
        </button>
      </div>

      <TransactionTable
        data={trx?.data?.data}
        isLoading={isLoading}
        page={filters.page}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default Transactions;
